import React from "react";
import { Popover, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./TextWithPopover.module.css";

interface Props {
  text: string;
  popoverText: string;
}

const TextWithPopover = ({ text, popoverText }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Typography
        className={classes.link}
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onClick={handlePopoverOpen}
        fontSize={"0.875rem"}
        whiteSpace={"nowrap"}
      >
        {text}
      </Typography>
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          "& .MuiPaper-root": {
            maxHeight: "80vh",
            width: "fit-content",
            overflowY: "auto",
            marginLeft: 2,
            padding: 3,
            paddingTop: 3,
            paddingRight: 5,
            position: "relative",
            bgcolor: "var(--primary-color)",
            color: "white",
          },
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: 8, right: 8, color: "white" }}
          size="small"
          onClick={handlePopoverClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <Typography>{popoverText}</Typography>
      </Popover>
    </div>
  );
};

export default TextWithPopover;
